import { restApiRP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getAll = params => {
  return restApiRP.post("/api/psi-simulation", params);
};

const getAllForCSV = params => {
  return restApiRP.post("/api/psi-simulation/csv", params);
};

const updateSimulationData = data => {
  return restApiRP.post("/api/psi-simulation/upsert", data);
}

const confirmVersion = versionId => {
  return restApiRP.post("/api/psi-simulation/confirm", versionId);
};

const replanConfirmVersion = versionId => {
  return restApiRP.post("/api/psi-simulation/replan-confirm", versionId);
};

const getAllForRawCSV = params => {
  return fetch("/api/psi-simulation/raw-csv", {
    body: ResponseUtil.getExportParamsForPost(params),
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`,
      "x-module-name": "RP"
    }
  });
};

const upsertRpPolicy = data => {
   return restApiRP.post("/api/psi-simulation/upsert-rp-policy", data);
};

const psiSimulationService = {
  getAll,
  getAllForCSV,
  updateSimulationData,
  confirmVersion,
  replanConfirmVersion,
  getAllForRawCSV,
  upsertRpPolicy
};

export default psiSimulationService;